<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputPassword4">Name</label>
    <input type="text" name='registration' [(ngModel)]='this.bonusLevel.name' [class.is-invalid]='!this.bonusLevel.name'  class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Rate (per hour)</label>
    <input type="number" name='vinNumber' [(ngModel)]='this.bonusLevel.value' [class.is-invalid]='!this.bonusLevel.value' class="form-control" id="inputPassword4">
  </div>
  </div>


